export default __webpack_public_path__ + "static/media/action-add_darkGray1.e7bd72a3.svg";